import * as React from 'react';
import { useContext } from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import { TFunction } from '../i18n/i18n';
import { ErrorReporter } from '../v2/errorReporter/ErrorReporter';
import { ErrorReporterContext } from '../v2/contexts/ErrorReporterContext';

export type WithTranslations = Omit<WithTranslation, 't'> & { t: TFunction };

const translator = withTranslation();
export const withTranslations = <P extends WithTranslations>(
  Cmp: React.ComponentType<P>,
): React.ComponentType<Omit<P, keyof WithTranslations>> => {
  // FIXME: error handling should be handled by "@wix/wix-i18n-config"
  const safeT = (t: TFunction, errorReporter: ErrorReporter): TFunction => (...args: Parameters<TFunction>) => {
    try {
      return t(...args);
    } catch (error) {
      errorReporter.reportError(error);
      return args[0];
    }
  };
  const SafeCmp = ({ t, ...props }) => {
    const errorReporter = useContext(ErrorReporterContext);
    // @ts-ignore
    return <Cmp t={safeT(t, errorReporter)} {...props} />;
  };
  // @ts-ignore
  return translator(SafeCmp);
};
